import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const solutions = [
  {
    title: "ELEVATOR SOLUTIONS",
    description: "Precision-engineered vertical mobility systems for modern infrastructure.",
    icon: "ArrowUp",
    link: "/elevator-solutions",
    color: "bg-[#4D4C4A]"
  },
  {
    title: "HVAC & PRECISION COOLING",
    description: "Advanced climate control systems designed for efficiency and comfort.",
    icon: "Wind",
    link: "/ac-maintenance-services",
    color: "bg-[#91756A]"
  },
  {
    title: "SMART BUILDING INTEGRATION",
    description: "Intelligent systems that connect and optimize building performance.",
    icon: "Cpu",
    link: "/smart-home-services",
    color: "bg-slate-200"
  }
];

const CoreSolutions = () => {
  return (
    <section className="py-24 bg-slate-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-8">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-sm font-bold uppercase tracking-[0.3em] text-[#91756A] mb-4">Our Core Solutions</h2>
            <h3 className="text-4xl font-bold text-[#4D4C4A] italic">Engineering the Future.</h3>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="max-w-md text-slate-500"
          >
            <p>Comprehensive engineering services tailored to meet the evolving needs of modern urban environments.</p>
          </motion.div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {solutions.map((solution, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="group relative bg-white p-10 hover:shadow-2xl transition-all duration-500 overflow-hidden"
            >
              <div className={`w-12 h-12 ${solution.color} rounded-sm flex items-center justify-center mb-8 transition-transform duration-500 group-hover:scale-110 group-hover:rotate-6`}>
                <Icon 
                  name={solution.icon} 
                  size={24} 
                  className={solution.color === 'bg-slate-200' ? 'text-[#4D4C4A]' : 'text-white'} 
                />
              </div>
              <h4 className="text-xl font-bold text-[#4D4C4A] mb-4 tracking-tighter italic uppercase group-hover:text-[#91756A] transition-colors duration-300">
                {solution.title}
              </h4>
              <p className="text-slate-500 mb-8 leading-relaxed">
                {solution.description}
              </p>
              <Link 
                to={solution.link}
                className="inline-flex items-center text-xs font-bold uppercase tracking-widest text-[#4D4C4A] group-hover:translate-x-2 transition-transform duration-300"
              >
                Learn More <Icon name="ArrowRight" size={14} className="ml-2" />
              </Link>
              
              {/* Background Accent */}
              <div className="absolute top-0 right-0 w-24 h-24 bg-slate-50 -mr-12 -mt-12 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoreSolutions;